import styled, { css } from 'styled-components'
import { AdvertImage } from '@at/design-system-patterns'
import { Button } from '@at/design-system-elements'

export const StyledImageLoading = styled.div`
    width: 100%;
    aspect-ratio: 4/3;
    background-color: ${({ theme }) => theme.color.bgFill.distinct};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    svg,
    path {
        fill: ${({ theme }) => theme.color.text.placeholder};
    }
    span {
        color: ${({ theme }) => theme.color.text.default};
    }
`

export const StyledImageLoadingText = styled.span`
    color: ${({ theme }) => theme.color.text.default};
    text-align: center;
`

export const StyledAdvertImage = styled(AdvertImage)`
    &.blur-image {
        filter: blur(15px);
        object-fit: cover;
    }
    &.main-image {
        background-color: unset;
    }
`

export const StyledAdvertImageContainer = styled.div`
    overflow: hidden;
    position: relative;
    aspect-ratio: 4 / 3;
    > * {
        position: absolute;
    }
`

export const OverlayDiv = styled.div`
    ${({ theme }) => {
        return css`
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: ${theme.color.bgFill.intense};
            opacity: 0.6;
            z-index: 2;
        `
    }}
`

export const ButtonOnImageContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    behavior: smooth;
`

export const SeeAllImagesButton = styled(Button)`
    z-index: 3;
    pointer-events: all;
`
